export const NO_SCHOLARSHIP = 'No Scholarship';
export const NO_SCHOLARSHIP_LEVEL = -1;
export const FULL_SCHOLARSHIP = 'Full Scholarship';
export const FULL_SCHOLARSHIP_LEVEL = 99;
